import{t as o}from"./index-4dc2a358.js";import"emotion";import{_ as t}from"./index-f0957bd1.js";export default function(r){return t(o(r))}
